import { styled } from '@mui/system';

export const Root = styled('main')({
  maxWidth: 1200,
  margin: '0 auto',
});
